import { SnackbarColor, SnackbarIcon } from '@/types/enums/SnackbarEnums';
import { useSnackbarStore } from '@/stores/snackbarStore';
import { type SnackbarType } from '@/types/SnackbarType';
import { VSnackbar } from 'vuetify/components';
import type { SnackbarMessageType } from '@/types/SnackbarMessageType';

export function useSnackbar() {
    const snackbarStore = useSnackbarStore();

    const showSnackbar = (
        text: string,
        color: SnackbarColor = SnackbarColor.Info,
        icon: SnackbarIcon = SnackbarIcon.Info,
        variant: VSnackbar['$props']['variant'] = 'flat',
        timeout: number = 5000,
    ): void => {
        const snackbar: SnackbarType = {
            text,
            color,
            icon,
            variant,
            timeout,
        };

        snackbarStore.addSnackbar(snackbar);
    };

    const handleSnackbarError = (errorMessage: string): SnackbarMessageType => {
        return {
            text: errorMessage,
            icon: SnackbarIcon.Error,
            color: SnackbarColor.Error,
        };
    };

    const handleSnackbarSuccess = (successMessage: string): SnackbarMessageType => {
        return {
            text: successMessage,
            icon: SnackbarIcon.Success,
            color: SnackbarColor.Success,
        };
    };

    const showSnackbarMessage = (message: SnackbarMessageType): void => {
        showSnackbar(message.text, message.color, message.icon);
    };

    return { showSnackbar, handleSnackbarSuccess, handleSnackbarError, showSnackbarMessage };
}
